import { graphql } from "gql";

const HAPPYCO_USER_WORK_ORDERS_QUERY = graphql(`
  query HappycoUserWorkOrders {
    happycoUserWorkOrders {
      ...HappycoWorkOrder
    }
  }
`);

export default HAPPYCO_USER_WORK_ORDERS_QUERY;
